
export class ElectronicTransferModel {
  currency: string = "MXN";
  description: string = "Dispersión a Cuenta Electrónica";
  deviceSessionId: string;
  listOfCustomers: MemberWalletModel[];
}

export class MemberWalletModel {
  username: string;
  active: boolean;
  activationDate: string;
  createDate: string;
  firstName: string;
  middleName?: string;
  lastName:string;
  birthday: string;
  nickname?: string;
  phoneNumber?: string;
  walletCustomerId: string;
  lastUpdate: string;
  amount?: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/transfers/member-wallet.model.ts